import { registerCharacterTools } from './modules/characterTools'
import { registerDiceTools } from './modules/diceTools'
import { registerNoteTools } from './modules/noteTools'
import { registerSpellTools } from './modules/spellTools'
import { registerMonsterTools } from './modules/monsterTools'
import { registerClassTools } from './modules/classTools'

export function registerDefaultAiTools() {
  registerCharacterTools()
  registerDiceTools()
  registerNoteTools()
  registerSpellTools()
  registerMonsterTools()
  registerClassTools()
}
